var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"visually-hidden",style:(_vm.computedStyle),attrs:{"aria-hidden":_vm.ariaHidden,"aria-live":_vm.ariaLive}},'div',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }